//Replicate for stage and prod
export const environment = {
  production: false,
  environment: 'dev',
  title: 'Sierra Production',
  name: 'sierra-production',
  asset: {
    stationAssetTypeReference: '67abfb9aee06eac3505f9834',
    doubleKnitAssetTypeId: '67acdba2ee06eac3505f985f',
  },
  proxyUrls: {
    assetApi: 'https://asset.api.dev.sierra-erp.com',
    itemApi: 'https://item.api.dev.sierra-erp.com',
    userMasterApi: 'https://user.api.dev.sierra-erp.com',
    inventoryApi: 'https://inventory.api.dev.sierra-erp.com',
    orderApi: 'https://order.api.dev.sierra-erp.com',
    productionApi: 'https://production.api.dev.sierra-erp.com',
    financeApi: 'https://finance.api.dev.sierra-erp.com',
  },
  domainUrls: {
    inventoryUrl: 'https://www.inventory-dev.sierra-erp.com/',
  },
  externalSitesUrls: {
    itemModule: 'sierra.textiles.come',
  },
  // AWS IoT Core broker used by the weight stations that have a `weightTopic` on their asset.
  // These values are NOT secrets: access is controlled by the scoped Cognito guest role.
  // Run _infra/provision-production-ui-iot.sh to create the pool and get `identityPoolId`.
  awsIot: {
    region: 'us-east-1',
    endpoint: 'wss://a3v8i2fm4gtn52-ats.iot.us-east-1.amazonaws.com/mqtt',
    identityPoolId: 'us-east-1:73fd6485-386f-4c50-9334-eb0ecc0799bb',
  },
};
